import { Endpoint, RecordsForPage } from "../mb_constants";

/**
 * 
 * @param {*} page 
 * @param {*} search 
 * @returns 
 */
const MbApi_CustomerSupplierList = async (page, search, entity_type) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/customer_supplier/list?page=${page}&record_for_page=${RecordsForPage}${search ? `&search=${search}` : ''}&entity_type=${entity_type}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} code 
 * @param {*} entity_type 
 * @returns 
 */
const MbApi_CustomerSupplierGetByCode = async (code, entity_type) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/customer_supplier/get_by_code?code=${code}&entity_type=${entity_type}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} body 
 * @returns 
 */
const MbApi_CustomerSupplierCreate = async (body) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/customer_supplier/create`,
        {
            method: "POST",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            },
            body: body
        }
    );

    try{
        if(response.status == 201){
            const res = await response.json();
            if(res.Result == "OK"){
                return res.Json;
            }
        }
    }catch(_){

    }

    return false;
};

/**
 * 
 * @param {*} id_customer_supplier
 * @returns 
 */
const MbApi_CustomerSupplierDelete = async (id_customer_supplier) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/customer_supplier/delete?id_customer_supplier=${id_customer_supplier}`,
        {
            method: "DELETE",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            }
        }
    );

    try{
        if(response.status == 200){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;

};

export {
    MbApi_CustomerSupplierList,
    MbApi_CustomerSupplierCreate,
    MbApi_CustomerSupplierDelete,
    MbApi_CustomerSupplierGetByCode
}